<template>
<div>
    <!-- <linkbutton toplabel="Update person" @click="UpdatePerson()"/> -->
    <smallbutton @click="UpdatePerson()" :toplabel="updateText" :class="buttonclass"/>
    <!-- ACCT NOTE MODAL -->
      <actionmodal ref="mymodal"> 
        <template v-slot:body>
            <form ref="myform">
                <label class="titlelabel">{{updateText}}</label>

                <formentry inputid="firstname" :capitalize="paramTrue"  inputtype="text"  label="First Name" isrequired='True' v-model="person.FirstName" v-if="isVisible('FirstName')"/>
                <formentry inputid="lastname" :capitalize="paramTrue"   inputtype="text"  label="Last Name" isrequired='True' v-model="person.LastName"  v-if="isVisible('LastName')"/>

                <div class="entry"  v-if="isVisible('StudentGroup')">
                    <div class="entryTextDiv">
                        <label class="entryLabel" for="studentgroupselect">Student Group</label>
                    </div>
                    <div class="entryTextDiv">
                    <select name="" id="studentgroupselect" class='entrySelect' v-model="person.studentGroupId" @change="preselectGroup()" :required="isRequired('StudentGroup')" >
                        <option v-for="s in studentGroupList" :key="s.ID" :value="s.ID" >
                            {{s.Name}}
                        </option>
                    </select>
                    </div>
                </div>

                <div class="entry"  v-if="isVisible('Status')">
                    <div class="entryTextDiv">
                        <label class="entryLabel" for="statusselect">Current Status</label>
                    </div>
                    <div class="entryTextDiv">
                    <select name="" id="statusselect" class='entrySelect' v-model="person.statusID"   required >
                        <option v-for="s in filteredStatusList" :key="s.ID" :value="s.ID" >
                            {{s.Name}}
                        </option>
                    </select>
                    </div>
                </div>

                <formentry inputid="studentid" inputtype="text"  :label="idLabel"  v-model="person.StudentID"  v-if="isVisible('ID')" :isrequired="isRequired('ID')"/>
                
                <div class="entry"  v-if="isVisible('Location')">
                    <div class="entryTextDiv">
                        <label class="entryLabel" for="locationselect">Location</label>
                    </div>
                    <div class="entryTextDiv">
                    <select name="" id="locationselect" class='entrySelect' required v-model="person.locationId_Primary" @change="selectLocation()" >
                        <option v-for="loc in locationList" :key="loc.id" :value="loc.id" >
                            {{loc.name}}
                        </option>
                    </select>
                    </div>
                </div>
                <div class="entry"  v-if="isVisible('Department')">
                    <div class="entryTextDiv">
                        <label class="entryLabel" for="departmentselect">Department</label>
                    </div>
                    <div class="entryTextDiv">
                    <select name="" id="departmentselect" class='entrySelect'  v-model="person.departmentId"  >
                        <option v-for="d in departmentList" :key="d.id" :value="d.id" >
                            {{d.name}}
                        </option>
                    </select>
                    </div>
                </div>
                <div class="entry"  v-if="isVisible('PersonRole')">
                    <div class="entryTextDiv">
                        <label class="entryLabel" for="roleselect">Role</label>
                    </div>
                    <div class="entryTextDiv">
                    <select name="" id="roleselect" class='entrySelect' v-model="person.personRoleId" required @change="selectRole()">
                        <option v-for="role in personRoleList" :key="role.id" :value="role.id" >
                            {{role.name}}
                        </option>
                    </select>
                    </div>
                </div>
                <formentry inputid="pin" inputtype="text"  label="Pin"  v-model="person.Pin"  v-if="isVisible('Pin')" :isrequired="isRequired('Pin')"/>
                <formentry inputid="enrolldate" inputtype="date"  label="Enrollment Date"  v-model="person.enrollmentDate"  v-if="isVisible('EnrollmentDate')" :isrequired="isRequired('EnrollmentDate')"/>
                <formentry inputid="startdate" inputtype="date"  label="Start Date"  v-model="person.hireDate"  v-if="isVisible('StartDate')" :isrequired="isRequired('StartDate')"/>




                <br>
                <formentry inputid="birthdate" inputtype="date"  label="Birthdate"  v-model="person.Birthdate"  v-if="isVisible('Birthdate')" :isrequired="isRequired('Birthdate')"/>
                <formentry inputid="dl" inputtype="text"  label="DL"  v-model="person.InternalID"  v-if="isVisible('DL')" :isrequired="isRequired('DL')"/>
                <formentry inputid="permitexpirationdate" inputtype="date"  label="Permit Exp."  v-model="person.PermitExpirationDate"  v-if="isVisible('PermitExpirationDate')" :isrequired="isRequired('PermitExpirationDate')"/>
                <formentry inputid="ssn" inputtype="text"  label="SSN"  v-model="person.fId"  v-if="isVisible('SSN')" :isrequired="isRequired('SSN')"
                    :placeholder="FIDPlaceholder"/>
                <br>
                <div class="entry"  v-if="isVisible('Course')">
                    <div class="entryTextDiv">
                        <label class="entryLabel" for="coursetypeselect">Select Course Type</label>
                    </div>
                    <div class="entryTextDiv">
                    <select name="" id="coursetypeselect" class='entrySelect' v-model="person.ProductTypeGlobalKey"  @change="getProducts()" :required="isRequired('Course')">
                        <option v-for="ptype in ProductTypeList" :key="ptype.guid" :value="ptype.guid" >
                            {{ptype.name}}
                        </option>
                    </select>
                    </div>
                </div>
                <div class="entry"  v-if="isVisible('Course')">
                    <div class="entryTextDiv">
                        <label class="entryLabel" for="courseselect">Select Course</label>
                    </div>
                    <div class="entryTextDiv">
                    <select name="" id="courseselect" class='entrySelect' v-model="person.ProductGlobalKey"  @change="selectProduct()" :required="isRequired('Course')">
                        <option v-for="p in ProductList" :key="p.guid" :value="p.guid" >
                            {{p.name}} ( {{toCurrency(p.price)}})
                        </option>
                    </select>
                    </div>
                </div>
                <div class="entry"  v-if="isVisible('TuitionPaymentType')">
                    <div class="entryTextDiv">
                        <label class="entryLabel" for="tuitionselect">Sponsor</label>
                    </div>
                    <div class="entryTextDiv">
                        <select name="" id="tuitionselect" class='entrySelect' v-model="person.tuitionPaymentTypeID" @change="selectTuitionPaymentType()" >
                            <option v-for="sponsor in tuitionPaymentTypeList" :key="sponsor.id" :value="sponsor.id" >
                                {{sponsor.name}}
                            </option>
                        </select>
                    </div>
                    
                </div>
                <!-- if sponsor, allow entry -->
                <formentry  inputtype="text"  label="Sponsor Name"  v-model="person.sponsor"   v-if="person.TuitionPaymentTypeName=='Sponsor'"/>
                <div class="entry"  v-if="isVisible('ReferredBy')">
                    <div class="entryTextDiv">
                        <label class="entryLabel" for="sponsorselect">Referred By</label>
                    </div>
                    <div class="entryTextDiv">
                        <select name="" id="sponsorselect" class='entrySelect' v-model="person.referredId"  >
                            <option v-for="referred in referredByList" :key="referred.id" :value="referred.id" >
                                {{referred.Name}}
                            </option>
                        </select>
                    </div>
                </div>

                <formentry inputid="sponsorname" inputtype="text"  :label="sponsorOverrideText"  v-model="person.sponsor"  v-if="isVisible('Sponsor')" :isrequired="isRequired('Sponsor')"/>

                <formentry inputid="contractnumber" inputtype="text"  label="Contract #"  v-model="person.contractNumber"  v-if="isVisible('ContractNumber')" :isrequired="isRequired('ContractNumber')"/>
                


                <div class="entry"  v-if="isVisible('MealPlan')">
                    <div class="entryTextDiv">
                        <label class="entryLabel" for="mealplanselect">Meal Plan</label>
                    </div>
                    <div class="entryTextDiv">
                        <select name="" id="mealplanselect" class='entrySelect' v-model="person.MealPlan"  >
                            <option v-for="mealplan in mealplanList" :key="mealplan.MealPlanID" :value="mealplan.Name" >
                                {{mealplan.Name}}
                            </option>
                        </select>
                    </div>
                </div>

                <formentry inputid="charginlimit" inputtype="text"  label="Charging Limit"  v-model="person.chargingLimit"  v-if="isVisible('ChargingLimit')" />

                <br>
                <formentry inputid="emailaddress" inputtype="email"  label="Email Address"  v-model="person.EmailAddress"  v-if="isVisible('Email')" :isrequired="isRequired('Email')"/>
                <formentry inputid="phonenumber" inputtype="tel"  label="Phone Number" @blur="leavePhone"  v-model="person.PhoneNumber1"  v-if="isVisible('Phone')" :isrequired="isRequired('Phone')"/>
                

                 <formentry inputid="address1" label="Address 1"  v-model="person.AddressLine1"  v-if="isVisible('Address')" :isrequired="isRequired('Address')"/>
                <formentry inputid="address2" label="Address 2"  v-model="person.AddressLine2" v-if="isVisible('Address')"/>
                <formentry inputid="city" label="City" :capitalize="paramTrue"   inputtype="text"  v-model="person.City" v-if="isVisible('Address')" :isrequired="isRequired('Address')"/>
                <div class="entry" v-if="isVisible('Address')">
                    <div class="entryTextDiv">
                        <label class="entryLabel" for="stateselect">State</label>
                    </div>
                    <div class="entryTextDiv">
                    <select name="" id="stateselect" class='entrySelect' v-model="person.StateID" :required="isRequired('Address')">
                        <option v-for="state in states" :key="state.id" :value="state.id" >
                            {{state.name}}
                        </option>
                    </select>
                    </div>
                </div>
                <formentry inputid="zip" label="Zip"  v-model="person.ZipCode" v-if="isVisible('Address')" :isrequired="isRequired('Address')"/>
                <br>
                <div class="vertFlex" v-if="showLocationsEmployee && !isStudent">
                    <label class="  right10">Locations:</label>
                        <div v-for="pl in person.locationList" :key="pl.LocationID" :value="pl.LocationID" >
                            <div class="locationdiv3">
                                
                                <input :id="pl.LocationID" class="entryCheckbox2" type="checkbox" v-model="pl.IsActive" @input="pl.isDirty=true;" >
                                
                                
                                <label :for="pl.LocationID" class="nomargin" >{{pl.Name}}</label>
                            </div>
                            
                        </div>
                </div>


                <br>
                <div class="vertFlex ">
                    <label  class="" v-if="showOptInEmail || showOptInSMS">{{personTypeText}} agrees to receive communications through</label>
                    <label  class="" v-if="showOptInEmail && showOptInSMS">(Check at least one)</label>
                
                    <div class="horizFlex centered" v-if="showOptInEmail">
                        <input id="optinemailcheck" class="entryCheckbox" type="checkbox" v-model="person.optInForEmail" >
                        <label for="optinemailcheck" :class="checkClass(person.optInForEmail)">Email</label>
                    </div>

                    <div class="horizFlex topMargin centered" v-if="showOptInSMS">
                        <input id="optinsmscheck" class="entryCheckbox" type="checkbox" v-model="person.optInForText" @change="setoptsms">
                        <label for="optinsmscheck" :class="checkClass(person.optInForText)">Text Messaging</label>
                    </div>
                    <label v-if="showOptInSMS"  class="">({{personTypeText}} has given you consent to send text messages and understands that standard messaging and data rates may apply)</label>
                    

                    <div class="horizFlex topMargin centered" v-if="showOptInSMS && isAdd && isStudent" @change="setwelcome">
                        <input id="sendnewsms" class="entryCheckbox" type="checkbox" v-model="sendNewSMS" >
                        <label for="sendnewsms" :class="checkClass(sendNewSMS)">Check to send Welcome Text</label>
                    </div>
                </div> 
    
                
                <smallbutton  @click="checkNewperson()" toplabel="Save" />
                <smallbutton  @click="cancelupdate()" toplabel="Cancel"/>
                <div v-if="pleaseWait">
                    <label class="pleasewait">Please Wait...</label>
                </div>
                <div>
                    <label class="responsemessage">{{message}}</label>
               </div>
               <confirm ref="confirmgroup" :showButton="paramFalse" :body="a2dtoonboardwarning" title="Confirm Change Group"
                    @yes="selectGroup()" :redText="paramTrue"  @no="revertGroup()" />

                <confirm ref="confirmsavesamename" :showButton="paramFalse" :body="savewarning" title="Confirm Save With Same Name"
                    @yes="saveNewperson()" :redText="paramTrue"   />
                <confirm ref="confirmrole" :showButton="paramFalse" :body="changerolewarning" title="Confirm Change Role"
                    @yes="yeschangerole()" @no="nochangerole()" :redText="paramTrue"   />
          </form>
        </template>
      </actionmodal>
    </div>
</template>

<script>
import {mapFields} from 'vuex-map-fields'
import datamethods from '../../services/datamethods.js'
import format from '../../format.js'
import smallbutton from '../controls/button.vue'
import actionmodal from '../controls/actionmodal.vue'
import formentry from '../controls/entry.vue'
import linkbutton from '../controls/linkbutton.vue'
import pencilbutton from '../controls/pencilbutton.vue'
import securityhelper from '../../services/securityhelper.js'
import confirm from '../actions/confirm.vue'
export default {
    name:'updateperson',
    components:{
        smallbutton,
        actionmodal,
        formentry,
        linkbutton,
        pencilbutton,
        confirm
    },
    props:{
        inperson:{
            type:Object,
            required:true
        },
        personTypeText:{
            type:String,
            default:'Employee'
        },
        isAdd:{
            type:Boolean,
            default:false
        },
        buttonclass:{
            type:String,
            default:'updatebutton'
        },

    },
    mixins:[datamethods,format,securityhelper],
    data(){
        return{
            message:'',
            person:{},
            personRoleList:[],
            studentGroupList:[],

            ProductTypeList:[],
            ProductList:[],
            productSale: {
                walletId:-1,
                accountId:-1,
                locationId:-1,
                restrictToProductTypeGlobalKey:'',
                restrictToProductGlobalKey:'',
                price:0,
                walletTokenId:-1,
            },
           productamount:0,
           selectedRequiredFields:null,
           sendNewSMS:false,
           initialGroupId:0,
           initialGroupName:'',
           paramFalse:false,
           paramTrue:true,
           savewarning:null,
           changerolewarning:null,
           switchtabsaftersave:false,
           initialRoleId:0
        }
    },
    computed:{
        ...mapFields([
           'mealplanList',
           'locationList',
           'departmentList',
           'tuitionPaymentTypeList',
           'referredByList',
           'states',
           'statusList',
           'newPersonRequiredFieldsList',
           'loggedInUser',
           'pleaseWait'
        

        ]),
        filteredStatusList(){
            var outList=[]

            //employee
            if(this.isEmployee){
                this.statusList.forEach(myFunction2)
                function myFunction2(item, index, arr) {
                    let a=arr[index]
                    if(a.isEmployee){
                        outList.push(a)  
                    }
                }
            }else{
                //student
                this.statusList.forEach(myFunction2)
                function myFunction2(item, index, arr) {
                    let a=arr[index]
                    if(a.isStudent){
                        outList.push(a)  
                    }
                }
            }
            return outList
        },
       sponsorOverrideText(){
            if(window.SPONSOR_TEXT_OVERRIDE==undefined){return 'Sponsor'}
            else{return window.SPONSOR_TEXT_OVERRIDE}
       },
        idLabel(){
            if(this.isEmployee){ return "Employee #"}
            else{return "Student #"}
        },
        updateText(){
            if(this.isAdd){
                return "Add " + this.personTypeText
            }else{
                return "Update " + this.personTypeText
            }
            
        },
        isEmployee(){
            return this.personTypeText == 'Employee'
        },
        isStudent(){
            return this.personTypeText == 'Student'
        },
        FIDPlaceholder(){
            var placeholder=''
            if(window.SSN_LENGTH==undefined){placeholder='last 4 digits'}
            else if(window.SSN_LENGTH==4){placeholder='last 4 digits'}
            else{placeholder=window.SSN_LENGTH + ' digits'}
            return placeholder
        },
        FIDLength(){
            var l=4
            if(window.SSN_LENGTH!=undefined){l=window.SSN_LENGTH}
            return l
        },
        showOptInEmail(){
            if(window.SHOW_OPTIN_EMAIL==undefined){return false}
            else{return window.SHOW_OPTIN_EMAIL}
        },
        showOptInSMS(){
            if(window.SHOW_OPTIN_SMS==undefined){return false}
            else{return window.SHOW_OPTIN_SMS}
        },
        showLocationsEmployee(){
            
            if(window.SHOW_LOCATIONS_EMPLOYEE==undefined){return false}
            else{return window.SHOW_LOCATIONS_EMPLOYEE}
        },
        defaultLocationIsSelected(){
            var defloc = this.person.locationId_Primary
            var ispicked=false
           this.person.locationList.forEach(myFunction2)
                    function myFunction2(item, index, arr) {
                        let a=arr[index]
                        if(a.LocationID==defloc){
                            if(a.IsActive)
                            {
                               ispicked=true
                            }
                           
                        }
                    }
            return ispicked
        },
        a2dtoonboardwarning(){
            if(window.window.A2D_TO_ONBOARDING_WARNING_MESSAGE==undefined){return ''}
            else{return window.window.A2D_TO_ONBOARDING_WARNING_MESSAGE}
        },
    },
    methods:{
        formatLimit(lim){
            if(lim==-1){return null}
            else{return lim}
        },
        selectRole(checkforstutoempchange=true){
            

            console.log('sel role')

            var  name 
            var isEmployee=false
            var isStudent=false
            var id = this.person.personRoleId
            this.personRoleList.forEach(myFunction2)
            function myFunction2(item, index, arr) {
                    let acct=arr[index]
                    if(acct.id==id){
                        name=acct.name
                        isEmployee=acct.isEmployee
                        isStudent=acct.isStudent
                    }
                }
            this.person.personRoleName=name

            //if we are doing checked locations, then refresh the list based on the new role and precheck the default loc
            if(this.showLocationsEmployee){
                this.getPersonLocationList()
            }

            //if we are changing from stu to emp or emp to stu, warn and confirm
            if(checkforstutoempchange){
                if(this.isEmployee && isEmployee==false){
                    this.changerolewarning="You are changing to a Student Role. Please click Yes to confirm that is what you want.  After you save, your screen will switch to the Student Tab."
                    this.$refs.confirmrole.Show()
                }
                if(this.isStudent && isStudent==false){
                    this.changerolewarning="You are changing to an Employee Role. Please click Yes to confirm that is what you want.   After you save, your screen will switch to the Employee Tab."
                    this.$refs.confirmrole.Show()
                }
            }
            
        },
        yeschangerole(){
            //ok move on with your life. set flag so we change after save
            this.switchtabsaftersave=true
            console.log('chagnerole ' + this.switchtabsaftersave)
        },
        nochangerole(){
            //not such a great idea
            console.log('kidding')
            this.person.personRoleId=this.initialRoleId
            this.selectRole(false)//the false is don't check again for the change in role type
        },
        isSelected(id){

        },
        setoptsms(){
            //this.sendNewSMS= this.person.optInForText
        },
        setwelcome(){
            if(this.sendNewSMS){ this.person.optInForText=true}
        },
        isRequired(field){
            var required=false

            switch (field) {
                case 'ID':
                    if(this.isStudent){required= window.REQUIRE_ID}
                    else{required= window.REQUIRE_ID_EMPLOYEE}
                    break;
                case 'DL':
                    required= window.REQUIRE_DL
                    break;
                case 'Birthdate':
                    if(this.isStudent){required= window.REQUIRE_BIRTHDATE}
                    else{required= window.REQUIRE_BIRTHDATE_EMPLOYEE}
                    break;
                case 'Course':
                    required= window.REQUIRE_COURSE
                    break;
                case 'Address':
                    if(this.isStudent){required= window.REQUIRE_ADDRESS}
                    else{required= window.REQUIRE_ADDRESS_EMPLOYEE}
                    break;
                case 'Email':
                    required= window.REQUIRE_EMAIL
                    break;
                case 'Phone':
                    if(this.isStudent){required= window.REQUIRE_PHONE}
                    else{required= window.REQUIRE_PHONE_EMPLOYEE}
                    
                    break;
                case 'SSN':
                    required= window.REQUIRE_SSN
                    break;
                case 'ContractNumber':
                    required=false
                    break;
                case 'StudentGroup':
                    required = window.REQUIRE_GROUP
                    break;
                case 'StartDate':
                    required = false
                    break;
                default:
                    
                    break;
            }

            //if we have overrides, check that
            
            if(this.selectedRequiredFields!=null){
              
                switch (field) {
                    case 'ID':
                        required = this.selectedRequiredFields.requireID;
                        break;
                    case 'DL':
                        required = this.selectedRequiredFields.requireDL;
                        break;
                    case 'Birthdate':
                        required = this.selectedRequiredFields.requireBirthdate;
                        break;
                    case 'Course':
                        required = this.selectedRequiredFields.requireCourse;
                        break;
                    case 'Address':
                        required = this.selectedRequiredFields.requireAddress;
                        break;
                    case 'SSN':
                        required = this.selectedRequiredFields.requireSSN;
                        break;
                    case 'Phone':
                        required = this.selectedRequiredFields.requirePhone;



                        break;
                    case 'Email':
                        required = this.selectedRequiredFields.requireEmail;

                        

                        break;
                    case 'StartDate':
                        required = this.selectedRequiredFields.requireStartDate;
                        break;
                    default:
                        break;
                }
            }

            if(field=='Phone' && !required){
                        
                if(this.person.optInForText){required=true}
                console.log(this.person.optInForText + ' ' + required)
            }

            return required
        },
        isVisible(field){
            //console.log('isvis ' + field)
            switch (field) {
                case 'OptInEmail':
                    return window.SHOW_OPTIN_EMAIL
                    break;
                case 'OptInSMS':
                    return window.SHOW_OPTIN_SMS
                    break;
                case 'ID':
                    return window.SHOW_ID
                    break;
                case 'Status':
                    return this.isStudent && this.isAdd && window.SHOW_STATUS_UPDATESTUDENT;
                    break;
                case 'StudentGroup':
                    return this.isStudent && window.SHOW_STUDENTGROUP;
                    break;
                case 'DL':
                    return window.SHOW_DL && this.isStudent
                    break;
                case 'SSN':
                    return window.SHOW_SSN && this.isStudent
                    break;
                case 'Course':
                    return window.SHOW_COURSE && this.isStudent && this.isAdd
                    break;
                case 'TuitionPaymentType':
                    return window.SHOW_TUITIONPAYMENTTYPE && this.isStudent  
                    break;
                case 'Sponsor':
                    return window.SHOW_SPONSOR_ONLY && this.isStudent
                    break;
                case 'ReferredBy':
                    return window.SHOW_REFERREDBY && this.isStudent  && this.isAdd
                    break;
                case 'MealPlan':
                    return window.SHOW_MEALPLAN
                    break;
                case 'ChargingLimit':
                    return window.SHOW_CHARGINGLIMIT
                    break;
                case 'Address':
                    return window.SHOW_ADDRESS 
                    break;
                case 'Due':
                    return window.SHOW_ACCOUNT_DUE
                    break;
                case 'Balance':
                    return window.SHOW_ACCOUNT_BALANCE
                    break;
                case 'Birthdate':
                    return window.SHOW_BIRTHDATE
                    break; 
                case 'ContractNumber':
                    return window.SHOW_CONTRACTNUMBER
                    break;
                case 'Location':
                    return this.canAccess('View All Locations')
                    break;
                case 'StartDate':
                    return this.isStudent
                    break;
                case 'PersonRole':
                    if(this.isStudent){return window.SHOW_ROLE_STUDENT
                    }else{return window.SHOW_ROLE_EMPLOYEE}
                    
                    break;
                case 'Pin':
                    return window.SHOW_PIN
                    break;
                case 'Department':
                    return window.SHOW_DEPARTMENT
                    break;
                case 'PermitExpirationDate':
                    return window.SHOW_PERMIT_EXPIRATION_DATE && this.isStudent

                    break;
                case 'EnrollmentDate' :
                    return window.SHOW_ENROLLMENT_DATE && this.isStudent
                    break;
                default:
                    return true
                    break;
            }
        },
        isOKFID(fid){
            if(fid==null){return true}
            fid = fid.replaceAll('-','').replaceAll('.','').replaceAll(' ','')
           // console.log(fid.length)
            return fid.length==this.FIDLength
        },
        toCurrency(value){
            return "$" + Number(value).toFixed(2);
        },
       UpdatePerson(){
        this.switchtabsaftersave=false
        this.message=''
        
        if(this.isAdd){
            this.person = {
                ID:0,
                FirstName:null,
                LastName:null,
                StudentID:null,
                locationId_Primary:this.loggedInUser.LocationId,
                personRoleId:-1,
                Birthdate:null,
                fId:null,
                InternalID:null,
                tuitionPaymentTypeID:-1,
                TuitionPaymentTypeName:null,
                sponsor:null,
                referredId:-1,
                EmailAddress:null,
                MealPlan:null,
                AddressLine1:null,
                AddressLine2:null,
                City:null,
                StateID:-1,
                ZipCode:null,
                optInForText:false,
                optInForEmail:false,
                statusID:-1,
                password:11111111,
                studentGroupId:-1,
                PhoneNumber1:null,
                PermitExpirationDate:null,
                IsActive:true,
                enrollmentDate:null

            }
            this.sendNewSMS=false
        }else{
            this.person = this.inperson
            this.person.Birthdate = this.$options.filters.formatDateForInput(this.person.Birthdate)
            this.person.PermitExpirationDate = this.$options.filters.formatDateForInput(this.person.PermitExpirationDate)
             this.person.enrollmentDate = this.$options.filters.formatDateForInput(this.person.enrollmentDate)
            if(this.person.hireDate!=null){
                this.person.hireDate = this.$options.filters.formatDateForInput(this.person.hireDate)
            }
            this.initialGroupId=this.person.studentGroupId
            this.initialGroupName=this.person.studentGroupName
            this.initialRoleId=this.person.personRoleId
            this.selectGroup()
        }
        this.selectLocation()
        this.getRoles()
        this.getGroups()
        if(this.isVisible('Department')){this.getDepartments()}
        this.$refs.mymodal.openModal()
       },
        selectLocation(){
            this.getProductTypes()
        },
        preselectGroup(){
            var msg = this.a2dtoonboardwarning
            if(msg==''){this.selectGroup();return;}

            if(this.person.studentGroupId==1 && this.initialGroupName=='A2D'){
                this.$refs.confirmgroup.Show()
            }else{
                this.selectGroup()
            }
            
        },
        selectGroup(){

            console.log('sel grp')
            var selReqFields=null
            var groupid = this.person.studentGroupId
            this.newPersonRequiredFieldsList.forEach(myFunction2)

                function myFunction2(item, index, arr) {
                    let acct=arr[index]
                    if(acct.ID==groupid){
                        selReqFields = acct
                    }
                }

                this.selectedRequiredFields=selReqFields
        },
        revertGroup(){
            console.log('revert group')
            this.person.studentGroupId=this.initialGroupId
            this.person.studentGroupName=this.initialGroupName
            this.selectGroup()
        },
       /*  selectStatus(){
          //  console.log('sel status')
            var selReqFields=null
            var statusid = this.person.statusID
            this.newPersonRequiredFieldsList.forEach(myFunction2)

                function myFunction2(item, index, arr) {
                    let acct=arr[index]
                    if(acct.EmployeeStatusID==statusid){
                        selReqFields = acct
                    }
                }

                this.selectedRequiredFields=selReqFields
        }, */
        checkClass(selected){
            if(selected){
                return "entryCheckLabelbold"
            }else{
                return "entryCheckLabel"
            }
        },
        cancelupdate(){
            this.$refs.mymodal.closeModal()
            this.$emit('refresh')
            
        },
        async checkNewperson(){
if(this.$refs.myform.checkValidity()==false){
                this.message="Please complete all required fields before saving"
                return}
            //default to optinforemail if we aren't showing
            if(!this.showOptInEmail){
                this.person.optInForEmail=true
            }
            //if we show sms, and its checked, require phone
            if(this.showOptInSMS){
                if(this.person.optInForText && (this.person.PhoneNumber1=='' || this.person.PhoneNumber1==null)){
                    this.message="Please enter a phone number for text updates"
                    return
                } 
            }
            //if we show email, and its checked, require email
            if(this.showOptInEmail){
                if(this.person.optInForEmail && (this.person.EmailAddress=='' || this.person.EmailAddress==null)){
                    this.message="Please enter an email address for email updates"
                    return
                } 
            }
            //if we show both...one better be checked!!
            if(this.showOptInEmail && this.showOptInSMS && !this.person.optInForText && !this.person.optInForEmail){
                this.message="Please select either text or email updates"
                return
            }
           
            if(!this.isStudent){
                if(this.showLocationsEmployee && !this.defaultLocationIsSelected){
                        this.message="Please select the default location in the checklist or select a different default location"
                        return
                }
            }
           
            
            
            if(!this.isOKFID(this.person.fId)){
               // console.log('not ok fid')
                if(this.FIDLength==4){
                    this.message="Please enter the last 4 digits of your SSN"
                }else{
                    this.message="Please enter a " + this.FIDLength + ' digit SSN'
                }
                return
            }

            let req = {
                person:this.person,
                amount:this.productamount,
                sendSMS:this.sendNewSMS,
                removeOldJobRecords:!this.showLocationsEmployee || this.isStudent
            }

            this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(req,'checkperson')
            if(response.Successful){
             
               if(response.StringResponse !=null){
                //if success and msg, show choice to confirm
                this.savewarning=response.StringResponse
                this.$refs.confirmsavesamename.Show()
               }else{
                //if success but no msg, just go ahead and save
                this.saveNewperson()
               }
                
            }else{
                this.message = response.Message
            }
            this.pleaseWait=false;



        },
        async saveNewperson(){
            

            //verify capitalization
            this.person.FirstName = this.capitalizeWords(this.person.FirstName);
            this.person.LastName = this.capitalizeWords(this.person.LastName);
            //this.person.InternalID = this.capitalizeWords(this.person.InternalID);
            this.person.City = this.capitalizeWords(this.person.City);

            let req = {
                person:this.person,
                amount:this.productamount,
                sendSMS:this.sendNewSMS,
                removeOldJobRecords:!this.showLocationsEmployee || this.isStudent
            }

            this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(req,'updateperson')
            if(response.Successful){
                //save prod sale


                this.$refs.mymodal.closeModal()
                //console.log(response)

                if(this.isAdd){
                    this.$emit('refreshnew',response.person.ID, response.walletId)
                }else{
                    this.$emit('refresh',this.switchtabsaftersave)
                }
                
            }else{
                this.message = response.Message
            }
            this.pleaseWait=false;
        },
        capitalizeWords(str) {
            if(str==null){return null}
            return str.replace(/\b\w/g, char => char.toUpperCase());
        },
        leavePhone(){
            this.person.PhoneNumber1=this.$options.filters.formatPhone(this.person.PhoneNumber1);
        },
        selectTuitionPaymentType(){
            var name
            var id=this.person.tuitionPaymentTypeID
            this.tuitionPaymentTypeList.forEach(myFunction2)

                function myFunction2(item, index, arr) {
                    let acct=arr[index]
                    if(acct.id==id){
                        name = acct.name
                    }
                }
            this.person.TuitionPaymentTypeName=name
        },
        async getRoles(){
            let req = {
                locationId:-1,
                employeeOnly:false,
                studentOnly:false
            }
            //this.beforeAPI();
            var response = await this.callAPI(req,'rolelist')

            //handle response
            if(response.Successful){
            this.personRoleList = response.PersonRoleList
    
            if(this.personRoleList.length>0){
               //find student and pick it as default
               if(this.isStudent){
                var studentId=-1
                this.personRoleList.forEach(myFunction2)

                function myFunction2(item, index, arr) {
                    let acct=arr[index]
                    if(acct.name=='Student'){
                        studentId=acct.id
                    }
                }
                this.person.personRoleId=studentId
                this.person.personRoleName='Student'
               }
                
                
            }
            }else{
                this.message = response.Message
            }
            this.pleaseWait=false;
        },
        async getGroups(){
            
            //this.beforeAPI();
            var response = await this.callAPI(null,'studentgroups')

            //handle response
            if(response.Successful){
                this.studentGroupList = response.ValueList
            }else{
                this.message = response.Message
            }
            this.pleaseWait=false;
        },
        async getProductTypes(){
            let req = {
                walletId:0,
                locationId:this.person.locationId_Primary
            }
            this.$store.dispatch('beforeAPI');;
            var response = await this.callAPI(req,'producttypes')

            //handle response
            if(response.Successful){
            this.ProductTypeList = response.productTypeList
    
            if(this.ProductTypeList.length==1){
                //select the type to skip it
            
                this.getProducts(this.productTypeList[0].guid)
                
            }
            }else{
                this.message = response.Message
            }
            this.pleaseWait=false;
        },
        async getProducts(){
            var guid = this.person.ProductTypeGlobalKey
           // console.log('get prod ' + guid)
            this.selectedProductTypeGUID=guid
            let req = {
                walletId:0,
                locationId:this.person.locationId_Primary,
                productTypeGUID:guid
            }
            this.$store.dispatch('beforeAPI');;
            var response = await this.callAPI(req,'products')

            //handle response
            if(response.Successful){
            this.ProductList = response.productList
            
            }else{
            this.message = response.Message
            }
            this.pleaseWait=false;
        },
        async getDepartments(){
            this.message=""
            //call api
            var response = await this.callAPI(null,'departmentlist')
            //handle response
            this.tmpresp = response
            if(response.Successful){
                this.departmentList=response.DepartmentList
            }else{
                this.message = response.Message
            }
        },
       selectProduct(){
           var price=0;
           let guid = this.person.ProductGlobalKey
           this.ProductList.forEach(myFunction2)

            function myFunction2(item, index, arr) {
                let acct=arr[index]
                if (acct.guid==guid){
                    price=acct.price
                }
            }
            this.productamount=price
       },
       async saveTrans(){
     
            //send in to start transaction
            let req = this.productSale
            this.beforeAPI();
            var response = await this.callAPI(req,'productsale_admin')

            //handle response
            if(response.Successful){
            
            this.responseMessage="Product Transaction Completed"
            
            }else{
            this.message = response.Message
            }
            this.pleaseWait=false;

        
            
        },
        async getPersonLocationList(){
            //let prev = this.employeecurrentPerson.personId
            let req = {
                person:this.person
            }
            this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(req,'getpersonlocationlist')
            //handle response
            if(response.Successful){
                 this.person.locationList =response.Person.locationList;
                 this.fixlocations()
                 
            }else{
                this.responseMessage = response.Message
            }
            this.pleaseWait=false;  

        },
        fixlocations(){
            let mythis = this

            //add locations if we are doing taht
            if(this.showLocationsEmployee){
                var empid=this.person.ID
                this.locationList.forEach(myFunction2)
                function myFunction2(item, index, arr) {
                    let a=arr[index]
                    var id = a.id
                    var found=false
                    var newname =a.name
                    //look to see if htis is in our list
                    mythis.person.locationList.forEach(myFunction2)
                    function myFunction2(item, index, arr) {
                        let a=arr[index]
                        if(a.LocationID==id){
                            found=true
                           
                        }
                    }
                    if(!found){
                        let newone={LocationID:id, PersonID:empid, IsActive:false, isDirty:false, Name:newname}
                        mythis.person.locationList.push(newone)
                    }
                }
            }
            //make sure default loc is picked
            var defloc = this.person.locationId_Primary
            mythis.person.locationList.forEach(myFunction2)
                    function myFunction2(item, index, arr) {
                        let a=arr[index]
                        if(a.LocationID==defloc){
                            if(!a.IsActive)
                            {
                                a.IsActive=true
                                a.isDirty=true
                            }
                           
                        }
                    }
        },
        
    }
}
</script>

<style scoped>
.entryCheckLabel{
    margin:0px 0px 0px 5px;
    font-size:medium;
    text-align: left;  
    max-width: 420px;
}
.entryCheckLabelbold{
    margin:0px 0px 0px 5px;
    font-size:medium;
    text-align: left;  
    max-width: 420px;
    font-weight:bold;
}
.updatebutton{
    height:30px;
    width:150px;
    border-radius: 5px;
    padding:3px;
    margin:0px 0px 10px 0px;
}
@media screen and (max-width: 812px) {
   
   .entry{
       flex-direction: column;
   }
}
.entry{
   width: 100%;
   display:flex;

   justify-content: space-between;
}
.entryLabel{
   margin:2px;
   font-size:medium;
   text-align: left;   
}


.entryCheckbox{
   margin-left:5px;
}
.entryCheckbox2{
    width:15px;
}
.locationdiv3{
    display:grid;
    grid-template-columns: 1fr 10fr;
    text-align:left;
}
.entryText{
   margin:5px 0px 0px 0px;
   width:95%;
   font-size:medium;
 
}
.entrySelect{
   margin:5px 2px 5px 2px;
   width:98%;
   font-size:medium;

}
.entryTextDiv{
   display:flex;
   flex-direction: row;
   min-width: 250px;
}
.entryLabelDiv{
   display:flex;
   flex-direction: row;
   min-width: 250px;
}
</style>





























